export default "__VITE_ASSET__C$krN3sM__"